export const addNoteFunc = async (tag, title, phrase, addAfterTag, sectionId, displayNewId) => {
  return Word.run(async (context) => {
    let sectionIdContentControl = context.document.contentControls.getByTag(sectionId);
    sectionIdContentControl.load("styleBuiltIn");
    let startTag = addAfterTag + "__air";
    let startLocation = context.document.contentControls.getByTag(startTag);
    startLocation.load("text");

    // Load section's own __air for position validation when chaining off a predecessor note
    let sectionAirTag = sectionId + "__air";
    let sectionAir = addAfterTag !== sectionId
      ? context.document.contentControls.getByTag(sectionAirTag)
      : null;
    if (sectionAir) sectionAir.load("text");

    return context.sync().then(async () => {
      let element = startLocation.items[0];

      // Validate: predecessor note must be physically AFTER the section's __air.
      // Version mapping can leave notes in the wrong section area — if so, fall back
      // to the section's own __air to prevent cascading misplacement.
      if (addAfterTag !== sectionId && sectionAir && sectionAir.items.length > 0 && element) {
        let predecessorRange = element.getRange("Whole");
        let sectionAirRange = sectionAir.items[0].getRange("Whole");
        let comparison = predecessorRange.compareLocationWith(sectionAirRange);
        await context.sync();
        if (comparison.value === "Before" || comparison.value === "AdjacentBefore" || comparison.value === "OverlapsBefore") {
          console.warn(
            `KWord: Note predecessor "${addAfterTag}" is physically before section "${sectionId}". ` +
            `Falling back to section __air to prevent misplacement.`
          );
          element = sectionAir.items[0];
        }
      }

      let heading = "Note " + displayNewId + ': Kommentar til: "' + phrase + '"';
      let headingParagraph = element.insertParagraph(heading, "after");
      const parentHeading = sectionIdContentControl.items[0].styleBuiltIn;
      let currentHeadingLevel = parseInt(parentHeading.charAt(7)) + 1;
      headingParagraph.styleBuiltIn = "Heading" + currentHeadingLevel;
      let headingContentControl = headingParagraph.insertContentControl();
      headingContentControl.cannotEdit = true;
      headingContentControl.cannotDelete = true;
      headingContentControl.tag = tag;
      headingContentControl.title = title;
      headingContentControl.appearance = "Hidden";
      let startParagraph = headingContentControl.insertParagraph(
        "---------- (Skriv under her. Ikke slett eller marker denne tekstlinjen) ----------",
        Word.InsertLocation.after
      );
      // let startRange = startParagraph.insertText(" (" + "junk" + ")", "End");
      let startRange = startParagraph.insertText("", "End");
      startRange.font.color = "#FDD551";
      startRange.font.size = 4;
      startParagraph.style = "dbhelp";
      let startContentControl = startParagraph.insertContentControl();
      startContentControl.appearance = "Hidden";
      startContentControl.tag = tag + "__contentStart";
      startContentControl.cannotDelete = true;
      startContentControl.cannotEdit = true;
      startContentControl.title = phrase;
      let contentParagraph = startContentControl.insertParagraph("", Word.InsertLocation.after);
      contentParagraph.style = "db-00";
      let endParagraph = contentParagraph.insertParagraph(
        "---------- (Skriv over her. Ikke slett eller marker denne tekstlinjen) ----------",
        Word.InsertLocation.after
      );
      let endRange = endParagraph.insertText("", "End");
      // let endRange = endParagraph.insertText(" (" + "junk" + ")", "End");
      endRange.font.color = "#FDD551";
      endRange.font.size = 4;
      endParagraph.style = "dbhelp";
      let endContentControl = endParagraph.insertContentControl();
      endContentControl.appearance = "Hidden";
      endContentControl.tag = tag + "__contentEnd";
      endContentControl.title = phrase;
      endContentControl.cannotDelete = true;
      endContentControl.cannotEdit = true;
      let airParagraph = endContentControl.insertParagraph(" ", Word.InsertLocation.after);
      // let airParagraph = endContentControl.insertParagraph(" (" + "junk" + ")", Word.InsertLocation.after);
      airParagraph.style = "db-00";
      airParagraph.font.color = "#FFFFFF";
      airParagraph.font.size = 4;
      let airContentControl = airParagraph.insertContentControl();
      airContentControl.cannotEdit = true;
      airContentControl.cannotDelete = true;
      airContentControl.appearance = "Hidden";
      airContentControl.tag = tag + "__air";
      airContentControl.title = phrase;
      contentParagraph.select(Word.SelectionMode.end);
      return context.sync();
    });
  });
};

export const removeNoteFunc = async (tag) => {
  return Word.run(async (context) => {
    var contentControls = [];
    var head = context.document.body.contentControls.getByTag(tag);
    context.load(head);
    contentControls.push(head);
    var contentEnd = context.document.body.contentControls.getByTag(tag + "__contentEnd");
    context.load(contentEnd);
    contentControls.push(contentEnd);
    var air = context.document.body.contentControls.getByTag(tag + "__air");
    context.load(air);
    contentControls.push(air);
    return context.sync().then(async () => {
      var expandedRange = contentControls[0].items[0]
        .getRange("Whole")
        .expandToOrNullObject(
          contentControls[2].items.length > 0
            ? contentControls[2].items[0].getRange("Whole")
            : contentControls[1].items[0].getRange("Whole")
        );
      context.load(expandedRange);
      return context.sync().then(() => {
        if (!expandedRange.isNullObject) {
          var lockedControls = expandedRange.contentControls;
          context.load(lockedControls);
          return context.sync().then(() => {
            for (var i = 0; i < lockedControls.items.length; i++) {
              lockedControls.items[i].cannotDelete = false;
              lockedControls.items[i].cannotEdit = false;
            }
            return context.sync().then(() => {
              head.items[0].select(Word.SelectionMode.end);
              expandedRange.delete(false);
              return context.sync();
            });
          });
        }
      });
    });
  });
};

export const reNumberingNoteIds = async (reNumberingArray) => {
  return Word.run(async (context) => {
    for (let index = 0; index < reNumberingArray.length; index++) {
      const reNumberingElement = reNumberingArray[index];
      const contentControls = context.document.contentControls.getByTag(reNumberingElement.tag);
      contentControls.load("tag, text, cannotEdit, cannotDelete, title, styleBuiltIn, appearance, items");
      await context.sync();
      const oldContentControl = contentControls.items[0];

      let headerText = oldContentControl.text;
      const colonIndex = headerText.indexOf(":");
      const remainingPart = headerText.slice(colonIndex);
      const newText = "Note " + reNumberingElement.newNoteIdNumber + remainingPart;
      // oldContentControl.insertText(newText, "Replace");

      // insertText with "Replace" does not work with content controls on Word Online version and this is a workaround
      let headingParagraph = oldContentControl.insertParagraph(newText, Word.InsertLocation.before);
      headingParagraph.styleBuiltIn = oldContentControl.styleBuiltIn;
      let headingContentControl = headingParagraph.insertContentControl();
      headingContentControl.cannotEdit = true;
      headingContentControl.cannotDelete = true;
      headingContentControl.tag = oldContentControl.tag;
      headingContentControl.title = oldContentControl.title;
      headingContentControl.appearance = "Hidden";
      // remove the old content control
      oldContentControl.cannotDelete = false;
      oldContentControl.delete();
      // End of workaround
    }
    return context.sync();
  });
};

export const goToComment = async (tag) => {
  return Word.run(async (context) => {
    let location = context.document.contentControls.getByTag(tag);
    location.load();
    return context.sync().then(() => {
      location.items[0].select(Word.SelectionMode.start);
      return context.sync();
    });
  });
};

const setLockBody = async (cannotEdit) => {
  return Word.run(async (context) => {
    let cc = context.document.body.contentControls.getByTag("bodylock");
    context.load(cc, "cannotEdit");
    return context.sync().then(() => {
      if (cc.items.length > 0) {
        cc.items[0].cannotEdit = cannotEdit;
        return context.sync();
      }
    });
  });
};

const changeCannotEditAndDeleteByTag = async (tagsArray, cannotBool) => {
  return Word.run(async (context) => {
    let wordElementArray = [];
    tagsArray.forEach((tag) => {
      let wordElement = context.document.body.contentControls.getByTag(tag);
      context.load(wordElement, "cannotEdit");
      wordElementArray.push(wordElement);
    });

    return context.sync().then(() => {
      wordElementArray.forEach((wordElement) => {
        if (wordElement.items.length > 0) {
          wordElement.items[0].cannotEdit = cannotBool;
          wordElement.items[0].cannotDelete = cannotBool;
        }
        return context.sync();
      });
    });
  });
};

export const getAllContentControls = () => {
  return Word.run(async (context) => {
    var cc = context.document.body.contentControls;
    context.load(cc);
    return context.sync().then(function () {
      var promise = new Promise(function (resolve, reject) {
        if (cc && cc.items) {
          lastCC = cc.items[cc.items.length - 1].tag; // you may use it later - it was defined as global var in kword2
          resolve(cc.items);
        } else {
          reject(console.error("NotFound", "No content controls found"));
        }
      });
      return promise;
    });
  });
};

export const handleWordSelectionForNavigation = async (abortController) => {
  return new Promise(async function (resolve, reject) {
    return Word.run(async (context) => {
      if (abortController.signal.aborted) return reject();
      var ps = context.document.getSelection().paragraphs;
      context.load(ps);
      return context.sync().then(async () => {
        if (abortController.signal.aborted) return reject();
        let parent = ps.items[0].parentContentControlOrNullObject;
        context.load(parent);
        return context.sync().then(async () => {
          if (abortController.signal.aborted) return reject();
          if (!parent.isNullObject && parent.tag) {
            var tag = parent.tag.replace("__contentStart", "").replace("__contentEnd", "");
            if (tag.length > 0) return resolve(tag);
            return resolve(false);
          }
          return resolve(false);
        });
      });
    });
  });
};

export const handleWordSelectionForManualSearch = async (abortController) => {
  return new Promise(async function (resolve, reject) {
    return Word.run(async (context) => {
      if (abortController.signal.aborted) return reject();
      let selection = context.document.getSelection();
      context.load(selection);
      return context.sync().then(async () => {
        if (abortController.signal.aborted) return reject();
        if (selection.text.length != 0) {
          return resolve(selection.text ?? "");
        }
        return resolve(false);
      });
    });
  });
};

export const handleWordSelectionForAutomaticSearch = async (abortController) => {
  return new Promise(async function (resolve, reject) {
    return Word.run(async (context) => {
      if (abortController.signal.aborted) return reject();
      let selection = context.document.getSelection();
      var ps = context.document.getSelection().paragraphs;
      context.load(selection);
      context.load(ps);
      return context.sync().then(async () => {
        if (abortController.signal.aborted) return reject();
        if (selection.text.length == 0) {
          let text = ps.items[0].text;
          let parent = ps.items[0].parentContentControlOrNullObject;
          context.load(parent);
          return context.sync().then(async () => {
            if (abortController.signal.aborted) return reject();
            if (parent.isNullObject || !parent.tag) {
              return resolve({ text: text, type: "clickOnParagraph" });
            } else {
              return reject();
            }
          });
        } else {
          return resolve({ text: selection.text, type: "selectedTextOnAutomaticTab" });
        }
      });
    });
  });
};

export const insertHyperLinkManual = async (link) => {
  return Word.run(function (context) {
    context.document.getSelection().hyperlink = link;
    return context.sync();
  });
};

export const insertHyperLinkAutomatic = async (element, variantLink, typeOfSearch) => {
  let phrase = element.Match;
  let start = element.Start;
  // let end = element.End;

  return Word.run(async function (context) {
    let selection = context.document.getSelection();
    context.load(selection);
    return context.sync().then(() => {
      if (typeOfSearch == "clickOnParagraph") {
        let cc = selection.paragraphs;
        context.load(cc);
        return context.sync().then(() => {
          if (cc.items.length > 0) {
            let range = cc.items[0].getRange("Whole");
            context.load(range);
            return context.sync().then(() => {
              let substrings = range.search(phrase, { matchCase: true });
              context.load(substrings);
              return context.sync().then(() => {
                if (substrings.items.length > 0) {
                  let pos = findLinkPos(range.text, phrase, start);
                  substrings.items[pos].hyperlink = variantLink;
                }
              });
            });
          }
        });
      } else if (typeOfSearch == "selectedTextOnAutomaticTab") {
        let cc = selection;
        context.load(cc);
        return context.sync().then(() => {
          let range = cc.getRange("Whole");
          context.load(range);
          return context.sync().then(() => {
            let substrings = range.search(phrase, { matchCase: true });
            context.load(substrings);
            return context.sync().then(() => {
              if (substrings.items.length > 0) {
                let pos = findLinkPos(range.text, phrase, start);
                substrings.items[pos].hyperlink = variantLink;
              }
            });
          });
        });
      }
    });
  });
};

const findLinkPos = (haystack, needle, start) => {
  let startPositions = indexOfAll(haystack, needle);
  return closestPosition(startPositions, start);
};

const indexOfAll = (haystack, needle) => {
  let arr = [];
  let pos = haystack.indexOf(needle);
  while (pos > -1) {
    arr.push(pos);
    pos = haystack.indexOf(needle, pos + 1);
  }
  return arr;
};

const closestPosition = (startPositions, start) => {
  let closest = 0;
  let minDiff = Number.MAX_SAFE_INTEGER;
  for (let i = 0; i < startPositions.length; i++) {
    let diff = Math.abs(startPositions[i] - start);
    if (diff < minDiff) {
      closest = i;
      minDiff = diff;
    } else {
      break;
    }
  }
  return closest;
};

export function findExistingLinks(ooxml) {
  return new Promise(async function (resolve, reject) {
    try {
      let answer = [];

      let parser = new DOMParser();
      let ooxmlDoc = parser.parseFromString(ooxml, "text/xml");
      let xmlBody = ooxmlDoc.getElementsByTagName("w:body");
      if (xmlBody) {
        let allTextChild = xmlBody[0].getElementsByTagName("w:t");
        let characterStartCount = 0;
        for (let index = 0; index < allTextChild.length; index++) {
          const element = allTextChild[index];
          let elem = element;
          let result = null;
          while (elem && elem.nodeName != "w:body" && !result) {
            if (elem.nodeName == "w:hyperlink") {
              let linkId = elem.getAttribute("r:id");
              let queryStr = "Relationship[Id=" + linkId + "]";
              let linkUrl = ooxmlDoc.querySelector(queryStr).getAttribute("Target");
              const characterEndCount = characterStartCount + element.textContent.length;
              result = { linkUrl: linkUrl, start: characterStartCount, end: characterEndCount };
            }
            elem = elem.parentNode;
          }
          if (result) {
            answer.push(result);
          }
          characterStartCount += element.textContent.length;
        }

        resolve(answer);
      } else {
        reject();
      }
    } catch (err) {
      reject();
    }
  });
}

export const getParagraphOoxml = async () => {
  return Word.run(async function (context) {
    let getSelection = context.document.getSelection()?.paragraphs;
    context.load(getSelection);
    return context.sync().then(() => {
      if (getSelection?.items[0]) {
        let ooxml = getSelection.items[0].getOoxml();
        return context.sync().then(() => {
          return ooxml.value;
        });
      } else {
        return false;
      }
    });
  });
};

export const getSelectionOoxml = async () => {
  return Word.run(async function (context) {
    let getSelection = context.document.getSelection();
    context.load(getSelection);
    return context.sync().then(() => {
      if (getSelection) {
        let ooxml = getSelection.getOoxml();
        return context.sync().then(() => {
          return ooxml.value;
        });
      } else {
        return false;
      }
    });
  });
};

export const test = async () => {
  return Word.run(async function (context) {
    let getSelection = context.document.getSelection();
    context.load(getSelection);
    return context.sync().then(() => {
      let res = getSelection.getHyperlinkRanges();
      context.load(res);
      return context.sync().then(() => {
        return res;
      });
    });
  });
};
